import { connect } from 'react-redux';
import { Card, Row, Col } from 'react-bootstrap';
import PropertySwitch from './components/PropertySwitch';
import BaseFeature from './BaseFeature';
import { REPEATER } from '../../../../../../utils/constantFeatures';
import PropertyDropdown from './components/PropertyDropdown';
import PropertyPicker from './components/PropertyPicker';
import { Trans, getI18n } from 'react-i18next';

class Repeater extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            autoDetectionState: (this.props.properties[REPEATER.physMinLevel].value === "Off") ? true : false,
            // modeSettingsEnabled: this.props.properties[REPEATER.enableModeSettings].value === 1 ? true : false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeAutoDetection = this.handleChangeAutoDetection.bind(this);
    }

    handleChange(propertyName, value) {
        const v = value;
        const newState = {[propertyName]:value};

        this.setState(newState);

        const state = { ...this.state, ...newState };

        this.props.handleChange(propertyName, v);
    }

    handleChangeAutoDetection(propertyName, value){
        this.setState({ autoDetectionState: value === '1' ? true : false });
        if(value === '1'){
            // this.props.properties[REPEATER.physMinLevel].value = 'Off';
            this.handleChange('rpt.pml', 'Off');
        } else {
            // this.props.properties[REPEATER.physMinLevel].value = this.props.properties[REPEATER.physMinLevel].valueMeta.initial;
            this.handleChange('rpt.pml', this.props.properties[REPEATER.physMinLevel].valueMeta.initial);
        }
    }

    render() {
        const levelAutoDetectionObject = {};
        const Min_Level_Auto_Detection = getI18n().t('Min_Level_Auto_Detection');
        levelAutoDetectionObject['info'] = {'displayName': Min_Level_Auto_Detection, 'name': '', 'unit': '', 'valueType': ''};
        levelAutoDetectionObject['value'] = this.state.autoDetectionState ? '1' : '0';
        levelAutoDetectionObject['valueMeta'] = {};

        return (
            <><Row>
                <Col sm={4}>
                    <Card className="card-feature-component" style={{ width: '100%'}}>
                        <div className="card-header-feature">
                            <Trans i18nKey="Repeater" />
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >

                            <PropertyDropdown
                                property={this.props.properties[REPEATER.updateDirectionsTWlimits]}
                                properties={this.props.properties[REPEATER.updateDirectionsTWlimits].valueMeta.availableValues}
                                title={this.props.properties[REPEATER.updateDirectionsTWlimits].info.displayName}
                                measureUnit={''}
                                step={1}
                                handleChange={this.handleChange}
                                dropdownStyle={{padding: '0px', display: 'flex', justifyContent: 'flex-end'}}
                                titleSize={6}
                                dropdownSize={6} />

                            <PropertySwitch
                                property={this.props.properties[REPEATER.modeDetection]}
                                title={this.props.properties[REPEATER.modeDetection].info.displayName}
                                handleChange={this.handleChange} />

                            <PropertySwitch
                                property={this.props.properties[REPEATER.manufactureReset]}
                                title={this.props.properties[REPEATER.manufactureReset].info.displayName}
                                handleChange={this.handleChange} />

                        </Card.Body>
                    </Card>
                </Col>
                <Col sm={4}>
                    <Card className="card-feature-component" style={{ width: '100%'}}>
                        <div className="card-header-feature">
                            <Trans i18nKey="Mode_Settings" />
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >
                            <PropertySwitch
                                property={this.props.properties[REPEATER.enableModeSettings]}
                                title={this.props.properties[REPEATER.enableModeSettings].info.displayName}
                                handleChange={this.handleChange} />
                            <PropertyDropdown
                                disabled={this.props.properties[REPEATER.enableModeSettings].value === '0'}
                                property={this.props.properties[REPEATER.modeDT8]}
                                properties={this.props.properties[REPEATER.modeDT8].valueMeta.availableValues}
                                // propertyDisplayFunc={getHours}
                                title={this.props.properties[REPEATER.modeDT8].info.displayName}
                                measureUnit={''}
                                step={1}
                                handleChange={this.handleChange}
                                dropdownStyle={{padding: '0px', display: 'flex', justifyContent: 'flex-end'}}
                                titleSize={6}
                                dropdownSize={6} />
                            <PropertySwitch
                                disabled={this.props.properties[REPEATER.enableModeSettings].value === '0'}
                                property={this.props.properties[REPEATER.modeDALIData]}
                                title={this.props.properties[REPEATER.modeDALIData].info.displayName}
                                handleChange={this.handleChange} />
                            <PropertyDropdown
                                disabled={this.props.properties[REPEATER.enableModeSettings].value === '0'}
                                property={this.props.properties[REPEATER.modeInputDevice]}
                                properties={this.props.properties[REPEATER.modeInputDevice].valueMeta.availableValues}
                                title={this.props.properties[REPEATER.modeInputDevice].info.displayName}
                                measureUnit={''}
                                step={1}
                                handleChange={this.handleChange}
                                dropdownStyle={{padding: '0px', display: 'flex', justifyContent: 'flex-end'}}
                                titleSize={6}
                                dropdownSize={6} />
                        </Card.Body>
                    </Card>
                </Col>
                <Col sm={4}>
                    <Card className="card-feature-component" style={{ width: '100%'}}>
                        <div className="card-header-feature">
                            <Trans i18nKey="Phys_Min_level" />
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >
                            <PropertyPicker
                                disabled={this.state.autoDetectionState}
                                property={this.props.properties[REPEATER.physMinLevel]}
                                title={this.props.properties[REPEATER.physMinLevel].info.displayName}
                                // measureUnit={''}
                                step={1}
                                handleChange={this.handleChange}
                                inputStyle={{padding: '0px', display: 'flex', justifyContent: 'flex-end', maxWidth: "auto", flexDirection: "row"}}
                                inputSize={8}
                                inputStyleInner={{maxWidth: '6rem'}} />

                            <PropertySwitch
                                property={levelAutoDetectionObject}
                                title={<Trans i18nKey={levelAutoDetectionObject.info.displayName} />}
                                handleChange={this.handleChangeAutoDetection} />
                        </Card.Body>
                    </Card>
                </Col>
            </Row></>
        );
    }

}

export default connect(
    // mapStateToProps,
    // mapDispatchToProps
)(Repeater);
